import { Component } from "react";
import "./Apropos.css";

class AproposData extends Component {
  render() {
    const { className, heading, text, video1, video2, ...rest } = this.props;

    // ✅ on ne garde que les attributs data-* (AOS)
    const dataAttrs = Object.keys(rest).reduce((acc, key) => {
      if (key.startsWith("data-")) acc[key] = rest[key];
      return acc;
    }, {});

    return (
      <div className={className} {...dataAttrs}>
        <div className="des-text">
          <h2>{heading}</h2>
          <p>{text}</p>
        </div>

        <div className="apropos-media">
          {video1 && (
            <video
              className="apropos-video"
              src={video1}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
            />
          )}

          {video2 && (
            <video
              className="apropos-video"
              src={video2}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata"
            />
          )}
        </div>
      </div>
    );
  }
}

export default AproposData;